import { Box } from '@mui/material'
import React from 'react'

type Props = React.PropsWithChildren

export const StatisticCard: React.FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        bgcolor: 'white',
        borderRadius: 2,
        boxShadow: 1
      }}
    >
      {children}
    </Box>
  )
}
